import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { SeoContent } from './components/SeoContent';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Set Document Title
    document.title = '新加坡爽吧 Shiok8 | 新加坡历史最悠久的专业Escort推荐平台 | Singapore Premium Escort';
    // Helper function to set or create meta tags
    const setMetaTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };
    // Set Meta Description
    setMetaTag('description', '新加坡爽吧Shiok8，自2003年成立，新加坡历史最悠久的专业Escort推荐平台。提供最优质、最可靠的Escort服务推荐。Singapore premier escort recommendation platform since 2003. Shiok8 Premium Escort Services.');
    // Set Meta Keywords
    setMetaTag('keywords', '新加坡爽吧, Shiok8, Singapore escort, 新加坡escort, premium escort Singapore, 专业陪伴服务, Geylang, 芽笼, escort recommendation, 新加坡按摩');
    // Cleanup function (optional, but good practice if component unmounts)
    return () => {
      document.title = 'Vite + React + TS'; // Reset to default if needed
      // We usually leave meta tags intact for SEO purposes even on unmount in SPAs
    };
  }, []);
  return <div className="min-h-screen w-full bg-brand-bg font-sans relative overflow-x-hidden selection:bg-brand-green/20 selection:text-brand-green flex flex-col" data-id="element-0">
      {/* Decorative Background Shapes (Hero Area) */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gradient-to-bl from-[#EBE5D5] to-transparent rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/3 pointer-events-none z-0" data-id="element-1" />
      <div className="absolute top-[400px] left-0 w-[600px] h-[600px] bg-gradient-to-tr from-[#EBE5D5] to-transparent rounded-full blur-3xl opacity-60 -translate-x-1/4 pointer-events-none z-0" data-id="element-2" />

      {/* SVG Curve to mimic the screenshot's sweeping background line */}
      <svg className="absolute top-0 left-0 w-full h-[900px] pointer-events-none opacity-[0.03] z-0" preserveAspectRatio="none" viewBox="0 0 1440 900" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3">
        <path d="M-100 900C200 900 400 600 800 400C1200 200 1400 0 1500 -100" stroke="#2A4D34" strokeWidth="120" strokeLinecap="round" data-id="element-4" />
      </svg>

      <Navbar data-id="element-5" />

      <main className="flex-grow flex flex-col" data-id="element-6">
        <HeroSection data-id="element-7" />
        <SeoContent data-id="element-8" />
      </main>

      <Footer data-id="element-9" />
    </div>;
}